
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { mixin as Clickaway } from 'vue-clickaway';

@Component({
  components: {},
  mixins: [ Clickaway ],
})
export default class BulkEditField extends Vue {
  @Prop()
    allowedFields!: IBulkResponse;

  selectetFields: IFieldsData[] = [];

  selectedFieldChange(field: IFieldsData) {
    if (this.selectetFields.includes(field)) {
      this.selectetFields.splice(this.selectetFields.indexOf(field), 1);
    } else {
      this.selectetFields.push(field);
    }
  }

  save() {
    this.$emit('save', this.selectetFields);
  }
  /**
   * Called when changes need to re-render
   */
  mounted() {
    this.selectetFields = [];
  }
  get getFields() {
    return this.allowedFields.fields || [];
  }

}
